import Home from '../Pages/Home';
import Flotte from '../Pages/Flotte';
import About from '../Pages/About';
import Reiseberichte from '../Pages/Reiseberichte';
import Gallerie from '../Pages/Gallerie';
import Downloads from '../Pages/Downloads';

const routes = [
    {
        path: '/',
        component: <Home />,
        label: 'Home',
    },
    {
        path: '/flotte',
        component: <Flotte />,
        label: 'Flotte',
    },
    {
        path: '/reiseberichte',
        component: <Reiseberichte />,
        label: 'Reiseberichte',
    },
    {
        path: '/gallerie',
        component: <Gallerie />,
        label: 'Gallerie',
    },
    {
        path: '/downloads',
        component: <Downloads />,
        label: 'Downloads',
    },
    {
        path: '/about',
        component: <About />,
        label: 'Über mich',
    },
    // {
    //     path: '/kontakt',
    //     component: <Kontakt />,
    //     label: 'Kontakt',
    // },
]

export default routes;